import React from 'react';
import { Link } from 'react-router-dom';
import FlowDiagram from './FlowDiagram';

const HowItWorksSection = ({ showLink = true }) => (
  <section className="vxm-section" id="how-it-works">
    <div className="vxm-container">
      <div className="vxm-section-head vxm-reveal">
        <p className="vxm-eyebrow">How it works</p>
        <h2 className="vxm-h2">From meeting to next conversation</h2>
        <p className="vxm-body">
          Share your details in the room, capture theirs, keep the context, and
          find them again. The card is one way to start. The system is
          what happens after.
        </p>
      </div>

      <FlowDiagram />

      {showLink && (
        <p className="vxm-body" style={{ marginTop: 'var(--vxm-space-6)' }}>
          <Link to="/how-it-works" className="vxm-link">
            See how it works in more detail
          </Link>
        </p>
      )}
    </div>
  </section>
);

export default HowItWorksSection;
